import React from "react"
import AuthMobileForm from "../../forms/auth/AuthMobileForm";

interface IAuthMobileProps{
    handleSaveMobile: any,
}

const AuthMobile: React.FC<IAuthMobileProps> = ({handleSaveMobile}) => {
    
    return (
        <React.Fragment>
            <AuthMobileForm saveMobile={handleSaveMobile} />
        </React.Fragment>
    )
}

export default AuthMobile
